import cn from 'classnames'
import React from 'react'

import { ReactComponent as LogoProject } from './assets/img/logo-project.svg'

import styles from './loader-logo.module.css'

type LoaderLogoProps = {
  className?: string
  isSmall?: boolean
}

export const LoaderLogo = React.memo(
  ({ className, isSmall = false }: LoaderLogoProps) => {
    return (
      <LogoProject
        className={cn(styles.container, className, {
          [styles.small]: isSmall === true
        })}
      />
    )
  }
)
